"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _default = function _default(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height;
  return (0, _preact.h)("svg", {
    width: "".concat(width, "px"),
    height: "".concat(height, "px"),
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, (0, _preact.h)("path", {
    d: "M37.5 32.0096C37.4989 33.6444 37.2 35.2095 36.6552 36.6542C35.2107 37.1995 33.6449 37.499 32.0095 37.5001H31.9905C30.3559 37.499 28.7906 37.2004 27.3461 36.6553C26.8012 35.211 26.5011 33.6453 26.5 32.01V31.991C26.5011 30.3562 26.8005 28.7911 27.3446 27.3465C28.7898 26.8015 30.3553 26.5016 31.9905 26.5006H32.0095C33.6449 26.5016 35.2107 26.8015 36.6551 27.3465C37.1996 28.7912 37.4988 30.3563 37.4999 31.9911V32.0101V32.0099L37.5 32.0096ZM53.6942 28.3334H40.8521L49.9326 19.2529C49.2197 18.2516 48.4245 17.3116 47.5553 16.4426L47.5549 16.4417C46.6866 15.5735 45.7474 14.7791 44.7472 14.0668L35.6667 23.1473V10.306C34.4589 10.1031 33.2362 10.0007 32.0114 10L31.9881 10C30.7635 10.0007 29.541 10.1029 28.3333 10.3058V23.148L19.2528 14.0675C18.2521 14.78 17.3125 15.5748 16.4439 16.4435L16.4406 16.4464C15.5732 17.3144 14.7795 18.2531 14.0678 19.2528L23.1483 28.3333H10.3058C10.3058 28.3333 10.0004 30.7456 10 31.9919V32.0078C10.0005 33.2339 10.1027 34.4579 10.3058 35.6671H23.1479L14.0674 44.7476C15.4954 46.7524 17.2479 48.505 19.2528 49.933L28.3333 40.8527V53.6942C29.5398 53.8968 30.7611 53.9991 31.9846 54H32.0161C33.2394 53.999 34.4605 53.8967 35.667 53.6942V40.852L44.7475 49.9325C45.7478 49.2202 46.6871 48.4257 47.5555 47.5574L47.5577 47.5558C48.4259 46.6873 49.2203 45.7481 49.9326 44.7478L40.8521 35.6671H53.6942C53.8968 34.4606 53.9991 33.2395 54 32.0162V31.9846C53.999 30.7613 53.8967 29.5401 53.6942 28.3337V28.3334Z",
    fill: "#EC5929"
  }));
};

exports.default = _default;